import AmendmentDocument from './AmendmentDocument'

export default AmendmentDocument
